<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f00iv-01.jpg"/></p>
<p class="pagebreak">
</p><div class="hidden">A</div>
<p class="copyright1" id="copyright"><a id="page_iv"></a>PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places, and incidents are either the product of the author’s imagination or used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Hardinge, Frances.<br/>The Lie Tree / by Frances Hardinge.<br/>pages cm<br/>Originally published in Great Britain in 2015 by Macmillan UK. Summary: On an island off the south coast of Victorian England, fourteen-year-old Faith investigates the mysterious death of her father, who was involved in a scandal, and discovers a tree that feeds upon lies and gives those who eat its fruit visions of truth.<br/>ISBN 978-1-4197-1895-3 (hardcover) — ISBN 978-1-61312-899-2 (ebook)<br/>[1. Gender role—Fiction. 2. Great Britain—History—Victoria, 1837–1901—Fiction. 3. Mystery and detective stories.] I. Title.<br/>PZ7.H21834 Li 2016<br/>[Fic]—dc23<br/>2015028326</p>
<p class="copyright">Text copyright © 2016 Frances Hardinge<br/>Title page illustrations copyright © 2016 Vincent Chong<br/>Book design by Maria T. Middleton</p>
<p class="copyright">First published in Great Britain in 2015 by Macmillan UK.</p>
<p class="copyright">Published in 2016 by Amulet Books, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.</p>
<p class="copyright">Amulet Books and Amulet Paperbacks are registered trademarks of Harry N. Abrams, Inc.</p>
<p class="copyright">Amulet Books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.</p>
<p class="copyrighta"><img alt="images" height="41" src="images/pub.jpg" width="170"/></p>
<p class="copyrightb">115 West 18th Street<br/>New York, NY 10011<br/><a class="nounder" href="http://www.abramsbooks.com" target="_blank">www.abramsbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0efe1552